"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.JustView = exports.JustForm = exports.WToggle = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var data_1 = require("../../data");
exports.WToggle = function (props) {
    var ViewUI = props.ViewUI, FormUI = props.FormUI, Data = props.Data, data = props.data, message = props.message;
    return (react_1["default"].createElement(data_1.Detail, { data: data, ViewUI: ViewUI, FormUI: FormUI, promise: Data.update, message: message }));
};
exports.JustForm = function (props) {
    var FormUI = props.FormUI, Data = props.Data, linkBack = props.linkBack, data = props.data, message = props.message;
    var history = react_router_dom_1.useHistory();
    var onUpdate = function (x) { return history.push(linkBack); };
    return (react_1["default"].createElement(data_1.Form, { data: data, UI: FormUI, promise: Data.update, onUpdate: onUpdate, message: message }));
};
exports.JustView = function (props) {
    var ViewUI = props.ViewUI, data = props.data;
    return react_1["default"].createElement(ViewUI, { data: data });
};
exports["default"] = exports.WToggle;
